/*
 * A commander's stations as their state reports them (every 5 s): what
 * each holds, its room (one capacity every good shares) and what's made
 * and used of each good there a minute. For the Selection tab's holdings.
 */

export interface StationInfo {
  /** Held, by good name. */
  freight: Map<string, number>;
  /** Room for each good (null until the server says). */
  capacity: number | null;
  /** Made and used a minute, by good name. */
  flow: Map<string, { made: number; used: number }>;
  /** Trains based here (null until the server says). */
  trains: number | null;
}

const stations = new Map<number, StationInfo>();

type Rates = { good: number; made_per_min: number; used_per_min: number };

export function setStationState(state: Record<string, unknown>): void {
  const goods = (state.goods as string[] | undefined) ?? [];
  const flows = new Map(
    ((state.economy as { stations?: { id: number; goods: Rates[] }[] } | undefined)?.stations ?? []).map((s) => [
      s.id,
      new Map(s.goods.map((g) => [goods[g.good], { made: g.made_per_min, used: g.used_per_min }])),
    ]),
  );
  stations.clear();
  for (const s of (state.stations as { id: number; freight: number[]; freight_capacity?: number; trains?: number }[] | undefined) ?? []) {
    // Freight lists goods from id 1 (munitions are a depot's stock).
    stations.set(s.id, {
      freight: new Map(s.freight.map((n, i) => [goods[i + 1], n])),
      capacity: s.freight_capacity ?? null,
      flow: flows.get(s.id) ?? new Map(),
      trains: s.trains ?? null,
    });
  }
}

/** Depot `id`'s holdings, if it's one of the commander's stations. */
export function stationInfo(id: number): StationInfo | undefined {
  return stations.get(id);
}
